import { Typography } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";

export const StatusWrapper = styled.div`
  color: var(--section-ebony-light-color, var(--ebony-light));
  background: var(--section-snow-background-color, var(--snow));
  border-radius: 4px;
  padding: 32px;
  margin-top: 24px;
  .copyable {
    width: 80%;
  }
`;

export const Title = styled(Typography.BodyText)`
  padding-bottom: 9px;
  font-weight: 600;
`;

export const StatusSettingBodyText = styled(Typography.BodyText)`
  color: var(--section-slate-color, var(--slate));
`;

export const DeleteButton = styled(Button)`
  margin: 32px 0;
  color: var(
    --deactivate-environment-button-color,
    var(--button-snow-color, var(--snow))
  );
`;
